import { render } from "./ReportCheating.vue?vue&type=template&id=39e56173&scoped=true"
import script from "./ReportCheating.vue?vue&type=script&lang=js"
export * from "./ReportCheating.vue?vue&type=script&lang=js"

import "./ReportCheating.vue?vue&type=style&index=0&id=39e56173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e56173"]])

export default __exports__